
import { computed, defineComponent } from 'vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  props: {
    number: { type: Number, required: true },
    showZero: { type: Boolean, default: false },
  },
  setup(props) {
    const showBadge = computed(() => (props.number > 0 ? true : props.showZero));
    const mainStore = useMainStore();

    return {
      showBadge,
      mainStore,
    };
  },
});
